import {
  VOUCHER_REDEEM,
  VOUCHER_SESSIONS,
  VOUCHER_VALIDATE_NSW,
  VOUCHER_VALIDATE_VIC,
} from '@gameday/common/constants/endpoints'

export default {
  validateNswVoucher: VOUCHER_VALIDATE_NSW, // 'gamedayapi/voucher/validatevoucher',
  validateVicVoucher: VOUCHER_VALIDATE_VIC, // 'gamedayapi/voucher/validatevicvoucher',
  redeemVoucher: VOUCHER_REDEEM, // 'gamedayapi/voucher/redeemvoucher',
  session: VOUCHER_SESSIONS, // 'gamedayapi/voucher/sessions',
}
